<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <div>
      <mrc_ess_iconGroup :is_disabled="disabled"
                         :showEdit="hasBtn('edit-role')"
                         :show_del="hasBtn('delete-role')"
                         @handleReturn="handleReturn"
                         @handleEdit="handleEdit"
                         @handleDel="handleDel"></mrc_ess_iconGroup>
      <v-tabs color="primary"
              v-model="tab"
              background-color="#eeeef0"
              grow>
        <v-tab v-for="item in tablist"
               class="text-capitalize"
               :key="item.name">
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <keep-alive>
            <component ref="baseSet"
                       :is="baseSet"
                       :loading="loading"
                       :disabled="disabled"
                       :propsParams="baseInfo"
                       @success="success1"
                       @cancel="cancel1"
                       @change="change"></component>
          </keep-alive>
        </v-tab-item>
        <v-tab-item>
          <keep-alive>
            <component ref="funcSet"
                       :is="funcSet"
                       :loading="loading"
                       @success="success1"
                       @cancel="cancel1"
                       :disabled="disabled"
                       :propsParams="permission"></component>
          </keep-alive>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import baseSet from '../components/baseSet'
import funcSet from '../components/funcSet'
import { role_info, role_update, role_del } from '@/service/api/role'
import moment from 'moment'
export default {
  components: {},
  props: {},
  data () {
    return {
      skeletonloading: true,
      loading: false,
      disabled: true,
      tab: 0,
      baseSet: baseSet,
      funcSet: funcSet,
      baseInfo: {},
      permission: [],
      newPermission: [],
    }
  },
  computed: {
    tablist () {
      return [
        {
          name: this.$t('label_base_set'),
          component: baseSet,
          params: this.baseInfo,
        },
        {
          name: this.$t('label_Functional_authority'),
          component: funcSet,
          params: this.permission,
        },
      ]
    },
  },
  created () { },
  mounted () {
    if (!this.$store.state.iconstatus) {
      this.disabled = false
    }
    this.tab = this.$store.state.tab
    this.getData()
  },
  methods: {
    change (val) {
      this.baseInfo = val
    },
    async success1 (val) {
      await this.success()
    },
    async cancel1 () {
      await this.getData()
      this.disabled = !this.disabled
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then(async () => {
      //     await this.getData()
      //     this.disabled = !this.disabled
      //   })
      //   .catch(() => { })
    },
    async getData () {
      this.skeletonloading = true
      const info = await role_info({ uuid: this.$store.state.uuid })
      if (info.code == 200) {
        const {
          uuid,
          role_name,
          role_short_code,
          role_description,
          is_used,
          org_level_uuid,
          sequence,
          effective_start_date,
          effective_end_date,
          userNum,
        } = info.data
        this.permission = info.mrbase_sys_function_permission
          ? info.mrbase_sys_function_permission
          : []
        this.baseInfo = {
          uuid,
          role_name,
          role_short_code,
          role_description,
          is_used,
          org_level_uuid,
          sequence: sequence ? sequence : 1,
          effective_start_date,
          effective_end_date,
          userNum,
        }
      }
      this.skeletonloading = false
    },
    // async cancel () {
    //   this.$myConfirm({
    //     content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
    //   })
    //     .then(async () => {
    //       await this.getData()
    //       this.disabled = !this.disabled
    //     })
    //     .catch(() => { })
    // },
    async success () {
      // console.log(this.$refs.funcSet.eleTree());
      // return
      // 先判断 基本数据是否都符合校验
      this.$refs.baseSet.$v.params.$touch()
      if (this.$refs.baseSet.$v.params.$error) {
        this.$Message({
          text: this.$t(
            'message_Please_fill_in_the_basic_setting_data_before_submitting'
          ),
          color: 'rgba(0,0,0,0.78)',
        })
        return
      }

      // this.$refs.funcSet.eleTree() 这是选中的数据
      let permission = []
      try {
        permission = this.$refs.funcSet.eleTree()
      } catch (error) {
        permission = this.permission
      }
      // console.log(permission)
      if (permission.length <= 0) {
        this.$Message({
          text: this.$t(
            'message_permission_list_must_select_at_least_one_item'
          ),
        })
        return
      }
      const obj = Object.assign({}, this.baseInfo, {
        mrbase_sys_function_permission: permission,
        effective_start_date: this.baseInfo.effective_start_date
          ? moment(this.baseInfo.effective_start_date).format('YYYY-MM-DD')
          : '',
        effective_end_date: this.baseInfo.effective_end_date
          ? moment(this.baseInfo.effective_end_date).format('YYYY-MM-DD')
          : '',
      })
      this.loading = true
      const update = await role_update(obj)
      if (update.code == 200) {
        this.$Message({ text: this.$t('message_The_operation_was_successful') })
        this.disabled = !this.disabled
      }
      this.loading = false
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    // 删除
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
        .then(async () => {
          const del = await role_del({
            uuid: this.$store.state.uuid,
          })
          if (del.code == 200) {
            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })
            this.$router.go(-1)
          }
        })
        .catch(() => { })
    },
  },
  watch: {
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_role_management'
          this.$store.commit('set_page_title', 'label_edit_role_management')
        }
        else {
          this.$route.meta.title = 'label_view_role_management'
          this.$store.commit('set_page_title', 'label_view_role_management')
        }
      }, immediate: true
    }
  },
}
</script>

<style scoped></style>
